export default __webpack_public_path__ + "08fe89d00330fde3de726febea1150d4.png";